var chunkMapping = {
	"webpack_container_remote_FinanceModule_Finance": [
		"webpack/container/remote/FinanceModule/Finance"
	],
	"webpack_container_remote_PaymentModule_Payment": [
		"webpack/container/remote/PaymentModule/Payment"
	],
	"webpack_container_remote_ReportModule_ReportModule": [
		"webpack/container/remote/ReportModule/ReportModule"
	],
	"webpack_container_remote_CustomerModule_Customer": [
		"webpack/container/remote/CustomerModule/Customer"
	],
	"webpack_container_remote_ReceiptModule_Receipt": [
		"webpack/container/remote/ReceiptModule/Receipt"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/FinanceModule/Finance": [
		"default",
		"./Finance",
		"webpack/container/reference/FinanceModule"
	],
	"webpack/container/remote/PaymentModule/Payment": [
		"default",
		"./Payment",
		"webpack/container/reference/PaymentModule"
	],
	"webpack/container/remote/ReportModule/ReportModule": [
		"default",
		"./ReportModule",
		"webpack/container/reference/ReportModule"
	],
	"webpack/container/remote/CustomerModule/Customer": [
		"default",
		"./Customer",
		"webpack/container/reference/CustomerModule"
	],
	"webpack/container/remote/ReceiptModule/Receipt": [
		"default",
		"./Receipt",
		"webpack/container/reference/ReceiptModule"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}